export function isIOS(): boolean {
  return /iPad|iPhone|iPod/.test(navigator.userAgent);
}

/**
 * Platform-appropriate maps deeplink.
 *   iOS        → maps:// (Apple Maps)
 *   Android    → https://maps.google.com/ (opens the Google Maps app via intent, falls back to web)
 *   Desktop    → https://maps.google.com/ (web)
 *
 * Prompt 04 notes the iOS "offer Apple or Google" action sheet was optional; we
 * default to Apple Maps on iOS and can revisit if inspectors prefer otherwise.
 */
export function getMapsLink(address: string): string {
  const q = encodeURIComponent(address.trim());
  if (isIOS()) return `maps://?q=${q}`;
  return `https://maps.google.com/?q=${q}`;
}
